import { useEffect } from "react";

const FluxRedirect = () => {
  useEffect(() => {
    window.history.replaceState(null, "", "/flux/index.html");
    // eslint-disable-next-line no-restricted-syntax -- /flux is a separately hosted static app, outside the router
    window.location.href = "/flux/index.html";
  }, []);

  return null; // or a loading indicator if you prefer
};

export default FluxRedirect;
